import {ApiComm} from "../comm";
import {UserAccessTokenDto, UserInfoDTO, NamecardDTO, NamecardEditReqDTO, NoobookPasswdModifyReqDTO } from "../dto/UserDTOs";
import {ResponseDTO} from "../dto/ResponseDTO";
import {genNoobookHeader} from "./Common";
import _ from "lodash";
import { NoobookFileInfoDTO } from "../dto/CommonDTOs";

export function login(loginId:string, loginPw:string):Promise<ResponseDTO<UserAccessTokenDto>>
{
    return ApiComm.postData<ResponseDTO<UserAccessTokenDto>>('/open/v1/login/password', {loginId:loginId, password:loginPw},genNoobookHeader(null, null, 'application/json', "app")).then(resp=>resp.data);
}

export function loginByKakao(authCode:string):Promise<ResponseDTO<UserAccessTokenDto>>
{
    return ApiComm.getData<ResponseDTO<UserAccessTokenDto>>(`/open/v1/login/kakao/${authCode}`, {},genNoobookHeader(null, null, 'application/json', "app")).then(resp=>resp.data);
}

/*export function findPasswordRequest(loginId:string):Promise<ResponseDTO<boolean>>
{
    //return ApiComm.getData<ResponseDTO<boolean>>('/fms/v1/user/find-password/sms-request', {email:loginId}).then(resp=>{resp.data.response=resp.data.ok;return resp.data;});
    return ApiComm.postData<ResponseDTO<boolean>>('/fms/v1/user/find-password/request', {email:loginId}).then(resp=>resp.data);
}*/




export function checkLoginId(loginId:string):Promise<ResponseDTO<boolean>>
{
    return ApiComm.getData<ResponseDTO<boolean>>(`/open/v1/user/loginid/${loginId}`, {},genNoobookHeader(null, null, 'application/json', "app")).then(resp=>resp.data);
}

export function createNoobookUser(params: { loginid: string; passwd: string; name: string; agreementConfirmed: boolean; privacyPolicyConfirmed: boolean; marketingConfirmed: boolean; marketingSmsConfirmed: boolean; marketingEmailConfirmed: boolean; marketingApppushConfirmed: boolean; email: string }): Promise<ResponseDTO<UserInfoDTO>> {
    return ApiComm.postData<ResponseDTO<UserInfoDTO>>(
        '/open/v1/user',
        params,
        genNoobookHeader(null, null, 'application/json', 'app')
    ).then(resp => resp.data);
}

export function modifyTerms(authToken:string, params: {agreementConfirmed: boolean; privacyPolicyConfirmed: boolean, marketingConfirmed: boolean, marketingSmsConfirmed: boolean, marketingEmailConfirmed: boolean, marketingApppushConfirmed: boolean}): Promise<ResponseDTO<UserInfoDTO>> {
    return ApiComm.putData<ResponseDTO<UserInfoDTO>>(
        '/close/v1/user/terms_of_service',
        params, 
        genNoobookHeader(authToken, null, 'application/json', 'app')
    ).then(resp => resp.data);
}


export function getUserInfo(authToken:string):Promise<ResponseDTO<UserInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<UserInfoDTO>>(
        '/close/v1/user',
        {},
        genNoobookHeader(authToken, null, 'application/json', 'app')
    ).then(resp=>resp.data);
}


export function uploadUserImageFile(authToken:string, file:File):Promise<ResponseDTO<UserInfoDTO>>
{
    return ApiComm.putFormData<ResponseDTO<UserInfoDTO>>(
        '/close/v1/user/image',
        {file:file},
        genNoobookHeader(authToken, null, 'multipart/form-data', 'app')
    ).then(resp=>resp.data);
}

export function modifyUserName(authToken:string, name:string):Promise<ResponseDTO<UserInfoDTO>>
{
    console.log("modifyUserName:", name);
    return ApiComm.putData<ResponseDTO<UserInfoDTO>>(
        '/close/v1/user/name',
        name,
        genNoobookHeader(authToken, null, 'text/plain', 'app')
    ).then(resp=>resp.data);
}

export function modifyHandphoneNum(authToken:string, handphoneNum:string):Promise<ResponseDTO<UserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<UserInfoDTO>>(
        '/close/v1/user/handphoneNum',
        handphoneNum,
        genNoobookHeader(authToken, null, 'text/plain', 'app')
    ).then(resp=>resp.data);
}

export function modifyMailingAddress(authToken:string, mailingAddr:string, mailingAddrDetail:string, mailingPostalCode:string):Promise<ResponseDTO<UserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<UserInfoDTO>>(
        '/close/v1/user/mailingAddress',
        {mailingAddr:mailingAddr, mailingAddrDetail:mailingAddrDetail, mailingPostalCode:mailingPostalCode},
        genNoobookHeader(authToken, null, 'multipart/form-data', 'app')
    ).then(resp=>resp.data);
}

export function inputEmail(authToken:string, email:string):Promise<ResponseDTO<string>>
{
    return ApiComm.postData<ResponseDTO<string>>(
        '/close/v1/user/email',
        email,
        genNoobookHeader(authToken, null, 'text/plain', 'app')
    ).then(resp=>resp.data);
}

export function resetEmailConfirmation(authToken:string):Promise<ResponseDTO<string>>
{
    return ApiComm.postData<ResponseDTO<string>>(
        '/close/v1/user/email/confirmation',
        {},
        genNoobookHeader(authToken, null, 'text/plain', 'app')
    ).then(resp=>resp.data);
}

export function confirmEmail(authToken:string, confirmCode:string):Promise<ResponseDTO<boolean>>
{
    return ApiComm.putData<ResponseDTO<boolean>>(
        `/close/v1/user/email/confirmation/${confirmCode}/true`,
        {},
        genNoobookHeader(authToken, null, 'application/json', 'app')
    ).then(resp=>resp.data);
}

export function getNamecard(authToken:string):Promise<ResponseDTO<NamecardDTO>>
{
    return ApiComm.getData<ResponseDTO<NamecardDTO>>(
        '/close/v1/user/namecard',
        {},
        genNoobookHeader(authToken, null, 'application/json', 'app')
    ).then(resp=>resp.data);
}




export function editNamecard(authToken:string, namecardEditReqDTO:NamecardEditReqDTO):Promise<ResponseDTO<NamecardDTO>>
{
    return ApiComm.putData<ResponseDTO<NamecardDTO>>(
        '/close/v1/user/namecard',
        namecardEditReqDTO,
        genNoobookHeader(authToken, null, 'application/json', 'app')
    ).then(resp=>resp.data);
}

export function uploadNamecardTempImageFile(authToken:string, file:File):Promise<ResponseDTO<NoobookFileInfoDTO>>
{
    return ApiComm.putFormData<ResponseDTO<NoobookFileInfoDTO>>(
        '/close/v1/user/namecard/image',
        {file:file},
        genNoobookHeader(authToken, null, 'multipart/form-data', 'app')
    ).then(resp=>resp.data);
}



/*
@GetMapping(value="/search")
	@PageableAsQueryParam
	public Page<UserInfoDTO> searchActiveUser(@UserAccount UserAccountDTO loginUser
			, @RequestParam(name="loginIdOrName", required=true) String loginIdOrName
			, Pageable pageable) 
 */

export function searchActiveUser(authToken:string, loginIdOrName:string, page:number, size:number):Promise<ResponseDTO<UserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<UserInfoDTO[]>>(`/close/v1/user/search`
        , {loginIdOrName:loginIdOrName, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function modifyPasswd(authToken:string, passwdModifyReq:NoobookPasswdModifyReqDTO):Promise<ResponseDTO<boolean>>
{
    return ApiComm.putData<ResponseDTO<boolean>>(
        '/close/v1/user/passwd',
        passwdModifyReq,
        genNoobookHeader(authToken, null, 'application/json', 'app')
    ).then(resp=>resp.data);
}



